'use strict';

angular.module('app').directive('reviewPopup', function($route, $timeout, $location, GTM) {
    function link() {
        $timeout(function() {
            if ($route.current.$$route && $route.current.$$route.controller !== "OperatorCtrl as operator" && $route.current.$$route.controller !==  "LiveaboardCtrl as operator" && $location.search().showRatingPopup && $location.search().showRatingPopup === 'show') {
                $('#review-btn-footer').click();
                GTM.event('reviews_write_new_start');
                $location.search('showRatingPopup', null);
            }
        }, 350);

    }

    return {
        restrict: 'A',
        link: link
    };
});